var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lmd-plan-header" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "top",
                    "label-width": "8em",
                    inline: true,
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 24, md: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { content: _vm.$t("planning.date") } },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "highlighted-input",
                                    attrs: {
                                      disabled:
                                        _vm.isManualAssignLoading ||
                                        _vm.isAutoAssignLoading,
                                      type: "date",
                                      clearable: false,
                                      placeholder: _vm.$t("dateRange.date"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options": { firstDayOfWeek: 7 },
                                    },
                                    on: { change: _vm.handlePlanDateChanges },
                                    model: {
                                      value: _vm.$planDate,
                                      callback: function ($$v) {
                                        _vm.$planDate = $$v
                                      },
                                      expression: "$planDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.isManualAssignLoading ||
                                          _vm.isAutoAssignLoading,
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "planning.placeholder.plateNumber"
                                        ),
                                      },
                                      on: {
                                        change: _vm.handleSelectedTruckChanges,
                                      },
                                      model: {
                                        value: _vm.$selectedTruck,
                                        callback: function ($$v) {
                                          _vm.$selectedTruck = $$v
                                        },
                                        expression: "$selectedTruck",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          value: null,
                                          disabled: _vm.$anyChanges,
                                        },
                                      }),
                                      _vm._l(
                                        _vm.$trucks,
                                        function (truck, index) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: truck.id,
                                              attrs: {
                                                disabled:
                                                  !_vm.helper.isUndefined(
                                                    _vm.isTruckIdExistInGlobal(
                                                      truck.id
                                                    )
                                                  ) ||
                                                  (truck.id !==
                                                    _vm.$selectedTruck &&
                                                    _vm.$anyChanges &&
                                                    !_vm.isAutoAssign),
                                                label: truck.plateNumber,
                                                value: truck.id,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        truck.plateNumber
                                                      ) +
                                                      " "
                                                  ),
                                                  _vm.getRoutes(truck.id).length
                                                    ? [_vm._v(" ● ")]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(truck.vehicleType)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.selectedPlanId !== "newPlanId",
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "planning.placeholder.searchDriver"
                                        ),
                                      },
                                      model: {
                                        value: _vm.$selectedDriver,
                                        callback: function ($$v) {
                                          _vm.$selectedDriver = $$v
                                        },
                                        expression: "$selectedDriver",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: null },
                                      }),
                                      _vm._l(
                                        _vm.driversList,
                                        function (driver) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: driver.RecId,
                                              attrs: {
                                                disabled:
                                                  _vm.blockedDrivers.includes(
                                                    driver.RecId
                                                  ),
                                                label:
                                                  driver.UserName +
                                                  " [" +
                                                  driver.Carplate +
                                                  "] ",
                                                value: driver.RecId,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(driver.UserName) +
                                                      " [" +
                                                      _vm._s(driver.Carplate) +
                                                      "] "
                                                  ),
                                                ]
                                              ),
                                              driver.UserName
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        float: "right",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          "" +
                                                            (driver[
                                                              "MonitorType"
                                                            ] === "M"
                                                              ? _vm.$t(
                                                                  "planning.mobile"
                                                                )
                                                              : _vm.$t(
                                                                  "planning.noMonitor"
                                                                ))
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "manual"
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        disabled: _vm.$selectedTruck !== null,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.tooltip.assignTruckWarningTitle"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              "· " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarning3"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.$selectedTruck === null ||
                                              _vm.isManualAssignLoading ||
                                              _vm.isAutoAssignLoading,
                                            filterable: "",
                                            placeholder: _vm.$t(
                                              "planning.placeholder.planId"
                                            ),
                                          },
                                          model: {
                                            value: _vm.selectedPlanId,
                                            callback: function ($$v) {
                                              _vm.selectedPlanId = $$v
                                            },
                                            expression: "selectedPlanId",
                                          },
                                        },
                                        [
                                          _vm._l(
                                            _vm.truckPlanIds,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: item,
                                                attrs: {
                                                  disabled:
                                                    _vm.isPlanIdBelongToDifferentUser(
                                                      item
                                                    ),
                                                  label: item,
                                                  value: item,
                                                },
                                              })
                                            }
                                          ),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "planning.createNewPlanId"
                                              ),
                                              value: "newPlanId",
                                            },
                                          }),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "manual" && !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.isAssignToTruckDisabled
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason1
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning1"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason2
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning2"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTruckDisabledDetails
                                              .reason3
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignTruckWarning3"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.assignToTruck"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                              disabled:
                                                _vm.isAssignToTruckDisabled ||
                                                _vm.isManualAssignLoading,
                                              loading:
                                                _vm.isManualAssignLoading,
                                            },
                                            on: { click: _vm.assignToTruck },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "truck-moving",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$props.type === "auto" && !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.$selectedOrders.length === 0
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                "· " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.assignTruckWarning2"
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("planning.autoAssign")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                              disabled:
                                                _vm.$selectedOrders.length ===
                                                  0 || _vm.isAutoAssignLoading,
                                              loading: _vm.isAutoAssignLoading,
                                            },
                                            on: {
                                              click: _vm.autoAssignToTruck,
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "truck-moving",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.$t("planning.savePlan"),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "disabled-btn-wrapper" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  !_vm.$anyChanges ||
                                                  _vm.isManualAssignLoading ||
                                                  _vm.isAutoAssignLoading,
                                                type: "primary",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.savePlan(
                                                    _vm.$plan,
                                                    _vm.isAutoAssign
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "save",
                                                  "aria-hidden": "true",
                                                  size: "lg",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm.areRoutesInTruckMultiplePlanner ||
                                        _vm.areRoutesInTruckCompleted
                                          ? _c("div", [
                                              _vm.areRoutesInTruckMultiplePlanner
                                                ? _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.disabledWrongUser"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.completedRoutes"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.deleteRoutesInTruck"
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.areRoutesInTruckMultiplePlanner ||
                                                _vm.areRoutesInTruckCompleted ||
                                                !_vm.$isPlanExists ||
                                                _vm.isManualAssignLoading ||
                                                _vm.isAutoAssignLoading ||
                                                _vm.$anyChanges ||
                                                !_vm.checkIfTruckHasRoutes,
                                              type: "danger",
                                              size: "mini",
                                            },
                                            on: { click: _vm.confirmDelete },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "trash-alt",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.isAssignDriverDisabled
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm.getAssignTrucksDisabledDetails
                                              .reason1
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignWarehouseWarning1"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTrucksDisabledDetails
                                              .reason2
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignWarehouseWarning5"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.assignTrucksToDrivers"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              disabled:
                                                _vm.isAssignDriverDisabled,
                                              size: "mini",
                                            },
                                            on: {
                                              click: _vm.assignTrucksToDriver,
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "people-carry",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                { staticClass: "d-none d-md-inline-block" },
                                [
                                  _c("el-tooltip", [
                                    _vm.isUnassignDriverDisabled
                                      ? _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.tooltip.assignTruckWarningTitle"
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm.getAssignTrucksDisabledDetails
                                              .reason1
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignWarehouseWarning1"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _vm.getAssignTrucksDisabledDetails
                                              .reason2
                                              ? _c("span", [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.assignWarehouseWarning5"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "planning.unassignTrucksFromDrivers"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _c(
                                      "span",
                                      { staticClass: "disabled-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              disabled:
                                                _vm.isUnassignDriverDisabled,
                                              size: "mini",
                                            },
                                            on: {
                                              click: _vm.confirmBatchUnassign,
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "hands",
                                                "aria-hidden": "true",
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isViewOnly
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass:
                                    "d-none d-md-inline-block float-right",
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: "user-lock",
                                      "aria-hidden": "true",
                                      size: "lg",
                                    },
                                  }),
                                  _vm._v(
                                    " " + _vm._s(_vm.occupyingMessage) + " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }